import _ from "lodash";
import { format } from "date-fns";
import DatePicker from "react-datepicker";

// constants
import { DATE_FORMAT } from "./constant";

// -------- form components
export const renderInputField = ({
  input,
  label,
  type,
  placeholder,
  max,
  min,
  validationText = null,
  errorEleId,
  mandatory,
  inputRef,
  meta: { touched, error, warning },
}) => {
  // console.log("error", error);
  // console.log("touched", touched);
  return (
    <>
      <div className="space-y-1 lg:space-y-2 block text-sm">
        <label className="">
          <span className="text-gray-700 dark:text-gray-400">
            {label}
            {validationText ? ` ${validationText}` : ""}
          </span>
          {mandatory ? (
            <>
              <span className="text-red-600">*</span>
            </>
          ) : (
            ""
          )}
        </label>
        <div className="flex flex-col w-full">
          <input
            className={`block w-full mt-1 text-sm rounded-sm ${
              error
                ? "border-red-600 focus:ring-red-400 focus:border-red-400 focus:shadow-outline-red"
                : "border-secondary3 focus:ring-primary focus:border-primary focus:shadow-outline-blue"
            } focus:outline-none form-input`}
            {...input}
            type={type}
            placeholder={placeholder}
            max={max ?? null}
            min={min ?? null}
            ref={inputRef}
          />
          <div className="h-4">
            <span id={errorEleId ?? null} className="mt-1 text-xs text-red-500">
              {error && touched ? error : ""}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export const renderInputFieldTextArea = ({
  input,
  label,
  type,
  placeholder,
  max,
  min,
  errorEleId,
  mandatory,
  inputRef,
  meta: { touched, error, warning },
}) => {
  return (
    <>
      <div className="space-y-1 lg:space-y-2 block text-sm">
        <label className="">
          <span className="text-gray-700 dark:text-gray-400">{label}</span>
          {mandatory ? (
            <>
              <span className="text-red-600">*</span>
            </>
          ) : (
            ""
          )}
        </label>
        <div className="flex flex-col w-full">
          <textarea
            // style={{ height: '100%' }}
            // className="form-control textarea-field"
            className={`block w-full mt-1 text-sm rounded-sm h-36 overflow-y-auto hide-scrolllbar ${
              error
                ? "border-red-600 focus:ring-red-400 focus:border-red-400 focus:shadow-outline-red"
                : "border-secondary3 focus:ring-primary focus:border-primary focus:shadow-outline-blue"
            } focus:outline-none form-input`}
            {...input}
            placeholder={placeholder ?? ""}
            ref={inputRef ?? null}
            // onChange={(e) => handleInputNote(e)}
          />
          {/* <input
            className={`block w-full mt-1 text-sm rounded-sm ${
              error
                ? 'border-red-600 focus:ring-red-400 focus:border-red-400 focus:shadow-outline-red'
                : 'border-secondary3 focus:ring-primary focus:border-primary focus:shadow-outline-blue'
            } focus:outline-none form-input`}
            {...input}
            type={type}
            placeholder={placeholder}
            max={max ?? null}
            min={min ?? null}
            ref={inputRef}
          /> */}
          <div className="h-4">
            <span id={errorEleId ?? null} className="mt-1 text-xs text-red-500">
              {error && touched ? error : ""}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export const renderInputFieldForEditModal = ({
  input,
  // value,
  label,
  type,
  placeholder,
  errorEleId,
  meta: { touched, error, warning },
}) => {
  // console.log(value);
  return (
    <div className="grid grid-cols-6">
      <div className="col-span-2 flex items-center justify-start">
        <span className="">{label}</span>
      </div>
      <div className="col-span-1 flex items-center justify-center">
        <span className="">:</span>
      </div>
      <div className="col-span-3 flex items-center justify-start ">
        <input
          className="max-w-lg block px-1 lg:px-2 xl:px-3 w-full h-4 xl:h-8 focus:ring-primary focus:border-primary text-xs xl:text-sm font-normal border-secondary3 rounded-sm xl:rounded bg-secondary"
          {...input}
          type={type}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export const renderDatePickerField = (field) => {
  const {
    input,
    selected,
    disabled = false,
    label,
    labelposition,
    errorEleId,
    meta: { touched, error, warning },
  } = field;

  // ----- controlling the value
  let value = input.value
    ? new Date(input.value)
    : selected
    ? new Date(selected)
    : null;
  let valueAfterFormat = value ? format(value, DATE_FORMAT) : null;

  return (
    <>
      <div className="space-y-1 lg:space-y-2">
        <label className="">
          <span className="text-gray-700 dark:text-gray-400">{label}</span>
          <span className="text-red-600">*</span>
        </label>
        <div className="flex flex-col w-full">
          <DatePicker
            selected={value}
            className={`block w-full mt-1 text-sm rounded-sm ${
              error
                ? "border-red-600 focus:ring-red-400 focus:border-red-400 focus:shadow-outline-red"
                : "border-secondary3 focus:ring-primary focus:border-primary focus:shadow-outline-blue"
            }   focus:outline-none  form-input `}
            {...input}
            value={valueAfterFormat}
            disabled={disabled}
            dateFormat={DATE_FORMAT}
          />
          <div className="h-4">
            <span id={errorEleId ?? null} className="mt-1 text-xs text-red-500">
              {error && touched ? error : ""}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

// -------- common components
export const CustomSpinner = () => {
  return (
    <>
      <svg
        role="status"
        className="inline w-4 h-4 text-white animate-spin"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="#E5E7EB"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};

export const renderWithoutInputField = (props) => {
  return (
    <div className="grid grid-cols-6">
      <div className="col-span-2 text-start">
        <span className="">{props?.label}</span>
      </div>
      <div className="col-span-1 text-center">
        <span className="">:</span>
      </div>
      <div className="col-span-3 text-start text-gray-500">
        <span className="break-words">{props?.data ?? ""}</span>
      </div>
    </div>
  );
};

export const HighlightText = ({ text = "", highlight = "" }) => {
  if (!highlight.trim()) {
    return <span>{text}</span>;
  }
  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = text.split(regex);

  return (
    <span>
      {parts.filter(String).map((part, i) => {
        return regex.test(part) ? (
          <mark key={i}>{part}</mark>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </span>
  );
};

{
  /* <LazyLoadImage
            alt="thumbnail goes here"
            effect="blur"
            placeholder={
              <img
                src={noimg}
                className="logo"
                alt="lazy load placeholder on error"
              />
            }
            className="w-full h-full"
            // src={teamDetails?.thumbnail}
            src={noimg}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noimg;
            }}
          /> */
}

export const renderSelect = ({
  input,
  label,
  placeholder,
  errorEleId,
  mandatory,
  opts,
  meta: { touched, error, warning },
}) => {
  //var { label, labelposition, meta, mandatory, errorEleId } = field;

  return (
    <>
      <div className="space-y-1 lg:space-y-2 block text-sm">
        {label ? (
          <label className="">
            <span className="text-gray-700 dark:text-gray-400 text-sm">
              {label}
            </span>
            {mandatory ? (
              <>
                <span className="text-red-600">*</span>
              </>
            ) : (
              ""
            )}
          </label>
        ) : (
          ""
        )}
        <div className="flex flex-col w-full">
          <select className="input-field common-field text-sm" {...input}>
            {placeholder ? (
              <option value="" key={label}>
                {placeholder}
              </option>
            ) : (
              ""
            )}
            {opts.map((object, index) => {
              return (
                <option key={`${object.value}-${index}`} value={object.value}>
                  {object.text}
                </option>
              );
            })}
          </select>
          <div className="h-4">
            <span id={errorEleId ?? null} className="mt-1 text-xs text-red-500">
              {error && touched ? error : ""}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export const renderRadio = ({
  input,
  label,
  type,
  checked,
  placeholder,
  errorEleId,
  mandatory,
  opts,
  meta: { touched, error, warning },
}) => {
  //var { label, labelposition, meta, mandatory, errorEleId } = field;
  return (
    <div className="">
      <label className="text-sm">
        <input {...input} type={type} />
        <span className="text-gray-700 dark:text-gray-400 mt-1 pl-2">
          {" "}
          {label}{" "}
        </span>
        <span className="radiomark"></span>
      </label>
      <div className="h-4">
        <span id={errorEleId ?? null} className="mt-1 text-xs text-red-500">
          {error && touched ? error : ""}
        </span>
      </div>
    </div>
  );
};

export const renderCheckbox = ({
  input,
  label,
  type,
  checked,
  placeholder,
  errorEleId,
  mandatory,
  opts,
  meta: { touched, error, warning },
}) => {
  //var { label, labelposition, meta, mandatory, errorEleId } = field;
  return (
    <div className="">
      <label className="text-sm">
        <input {...input} type={type} />
        <span className="text-gray-700 dark:text-gray-400 mt-1 pl-2">
          {" "}
          {label}{" "}
        </span>
        <span className="radiomark"></span>
      </label>
      <div className="h-4">
        <span id={errorEleId ?? null} className="mt-1 text-xs text-red-500">
          {error && touched ? error : ""}
        </span>
      </div>
    </div>
  );
};
